import { Champion } from 'lib/lucky-x-icons-2';
import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'store/hooks';

const RewardsCount = () => {
  const {
    raffleInfo: { is_hide_entry_count, winner_count, type },
    entryCount,
  } = useAppSelector((state) => state.raffleDetails);
  const [isHideRaffleEntryCount, setIsHideRaffleEntryCount] = useState(false);
  const [raffleWinnerCount, setRaffleWinnerCount] = useState(0);
  const [raffleType, setRaffleType] = useState('');
  const [raffleEntryCount, setRaffleEntryCount] = useState(0);

  useEffect(() => {
    setIsHideRaffleEntryCount(!!is_hide_entry_count);
    setRaffleWinnerCount(Number(winner_count));
    setRaffleType(String(type));
    setRaffleEntryCount(Number(entryCount));
  }, [entryCount, is_hide_entry_count, type, winner_count]);

  return (
    <div className="mb-3 mt-8 flex items-center justify-between lg:mt-0">
      <div className="flex items-center gap-5">
        <div className="text-2xl font-semibold text-neutral-100">Rewards</div>
        {raffleType === 'WALLET_COLLECTION' ? (
          <div className="text-sm font-medium text-neutral-300">
            Wallet Collection
          </div>
        ) : (
          <div className="flex h-7 items-center justify-center gap-1 rounded-[52px] border border-highlight-500 px-2 text-sm font-medium text-highlight-500">
            <Champion size={24} />
            <div>{raffleWinnerCount}</div>
          </div>
        )}
      </div>
      {!isHideRaffleEntryCount && (
        <div className="flex items-center gap-1 text-sm font-normal text-neutral-300">
          <div>Entries</div>
          <div>{raffleEntryCount}</div>
        </div>
      )}
    </div>
  );
};

export default RewardsCount;
